export const DOMAIN = WINDOW_DOMAIN
  ? WINDOW_DOMAIN
  : "http://14.177.235.12:8621";

export const API_VERSION = WINDOW_API_VERSION ? WINDOW_API_VERSION : "/api";

export const ROUTE_NAME = {
  TRANG_CHU: "/trang-chu",
  DANG_NHAP: "/dang-nhap",
  _403: "/chua-co-quyen",
  _401: "/token-het-han",
  _404: "/khong-tim-thay",
  _500: "/loi-may-chu",
  QUAN_LY_DANH_MUC: {
    NAME: "/",
    HO_SO_CAN_BO: {
      NAME: "quan-ly-can-bo",
      DANH_SACH: "",
      TAO: "quan-ly-can-bo/them-moi",
      SUA: "quan-ly-can-bo/:id/cap-nhat",
      XEM: "quan-ly-can-bo/:id",
      XEM_THUOC_DON_VI_NAME: "quan-ly-can-bo-cua-don-vi",
      XEM_THUOC_DON_VI: "quan-ly-can-bo-cua-don-vi/:id"
    },
    DON_VI: {
      NAME: "quan-ly-don-vi",
      DANH_SACH: "",
      TAO: "quan-ly-don-vi/them-moi",
      SUA: "quan-ly-don-vi/:id/cap-nhat",
      XEM: "quan-ly-don-vi/:id"
    },
    THONG_BAO_TUY_CHINH: {
      NAME: "thong-bao",
      DANH_SACH: "",
      XEM: "don-vi/:id"
    },
    TINH_THANH: {
      XEM: "tinh-thanh"
    }
  },
  QUAN_TRI_HE_THONG: {
    NAME: "/",
    VAI_TRO: "quan-ly-vai-tro",
    XEM_CHI_TIET_VAI_TRO: "quan-ly-vai-tro/:id/xem",
    XEM_CHI_TIET_GROUP: "quan-ly-group/:id/xem",
    CAP_NHAT_VAI_TRO: "quan-ly-vai-tro/:id",
    NGUOI_DUNG: "quan-ly-nguoi-dung",
    XEM_CHI_TIET_NGUOI_DUNG: "quan-ly-nguoi-dung/:id/xem",
    CAP_NHAT_NGUOI_DUNG: "quan-ly-nguoi-dung/:id",
    QUAN_LY_THONG_TIN_NGUOI_DUNG: "quan-ly-thong-tin-nguoi-dung",
    CAP_NHAT_THONG_TIN_NGUOI_DUNG: "quan-ly-thong-tin-nguoi-dung/:id/cap-nhat",
    CHI_TIET_QUAN_LY_CAN_BO: "quan-ly-thong-tin-can-bo-cua-don-vi",
    CHI_TIET_QUAN_LY_CAN_BO_NAME: "quan-ly-thong-tin-can-bo-cua-don-vi/:id",
    XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG: "quan-ly-thong-tin-nguoi-dung/:id",
    APP: {
      NAME: "quan-ly-app",
      TAO: "quan-ly-app/them-moi",
      SUA: "quan-ly-app/:id/cap-nhat",
      XEM: "quan-ly-app/:id"
    },
    PERMISSION: {
      NAME: "quan-ly-permission"
    },
    GROUP: {
      NAME: "quan-ly-group",
      TAO: "quan-ly-group/them-moi",
      SUA: "quan-ly-group/:id",
      XEM: "quan-ly-group"
    },
    CHUC_VU: {
      NAME: "quan-ly-chuc-vu",
      TAO: "quan-ly-chuc-vu/them-moi",
      SUA: "quan-ly-chuc-vu/:id/cap-nhat",
      XEM: "quan-ly-chuc-vu/:id"
    },
    NHOM_CHUC_VU: {
      NAME: "quan-ly-nhom-chuc-vu",
      TAO: "quan-ly-nhom-chuc-vu/them-moi",
      SUA: "quan-ly-nhom-chuc-vu/:id/cap-nhat",
      XEM: "quan-ly-nhom-chuc-vu/:id"
    },
    CAP_DON_VI: {
      NAME: "quan-ly-cap-don-vi",
      TAO: "quan-ly-cap-don-vi/them-moi",
      SUA: "quan-ly-cap-don-vi/:id/cap-nhat",
      XEM: "quan-ly-cap-don-vi/:id"
    },
    IMPORT: {
      NAME: "import"
    },
    DM_HE_THONG: {
      NAME: "quan-ly-dm-he-thong",
      TAO: "quan-ly-dm-he-thong/them-moi",
      SUA: "quan-ly-dm-he-thong/:id/cap-nhat",
      XEM: "quan-ly-dm-he-thong/:id"
    },
    DM_MENU_HE_THONG: {
      NAME: "quan-ly-dm-menu-he-thong",
      TAO: "quan-ly-dm-menu-he-thong/them-moi",
      SUA: "quan-ly-dm-menu-he-thong/:id/cap-nhat",
      XEM: "quan-ly-dm-menu-he-thong/:id"
    },
    DM_NHOM_MENU: {
      NAME: "quan-ly-dm-nhom-menu",
      TAO: "quan-ly-dm-nhom-menu/them-moi",
      SUA: "quan-ly-dm-nhom-menu/:id/cap-nhat",
      XEM: "quan-ly-dm-nhom-menu/:id"
    },
    THONG_BAO: {
      NAME: "quan-ly-thong-bao/",
      QUAN_LY_NGUON_NHAN_THONG_BAO: "quan-ly-nguon-nhan-thong-bao",
      QUAN_LY_LOAI_THONG_BAO: "quan-ly-loai-thong-bao"
    },
    LOG: {
      NAME: "quan-ly-log"
    }
  },
  THONG_BAO: {
    NAME: "/quan-ly-thong-bao",
    TAO_THONG_BAO: "/tao-thong-bao",
    CHI_TIET_THONG_BAO: "/chi-tiet-thong-bao/:id",
    DANH_SACH_THONG_BAO_THEO_DANH_MUC: "/thong-bao/:id",
    XEM_THONG_BAO: "/xem-thong-bao/:id"
  },
  QUAN_LY_THONG_BAO: "/quan-ly-thong-bao",
  THONG_BAO_CHO_DUYET: "/thong-bao-cho-duyet",
  LICH_LAM_VIEC: {
    NAME: "/quan-ly-lich-lam-viec",
    TAO_LICH_LAM_VIEC: "/tao-lich-lam-viec",
    DANH_SACH_LICH_LAM_VIEC: "/danh-sach-lich-lam-viec/:id"
  }
};

export const MENU_ROUTE_NAME = {
  TRANG_CHU: "Trang chủ",
  _401: "Token hết hạn",
  _403: "Chưa có quyền",
  _404: "Không tìm thấy",
  _500: "Lỗi máy chủ nội bộ",
  HO_SO: {
    NAME: "Hồ sơ",
    DANH_SACH: "Danh sách",
    CHI_TIET: "Chi tiết",
    TAO: "Tạo"
  },
  QUAN_LY_DANH_MUC: {
    NAME: "Quản lý danh mục",
    HO_SO_CAN_BO: {
      NAME: "Quản lý hồ sơ cán bộ",
      DANH_SACH: "Hồ sơ cán bộ",
      TAO: "Thêm mới hồ sơ cán bộ",
      SUA: "Sửa hồ sơ cán bộ",
      XEM: "Xem hồ sơ cán bộ",
      XEM_THUOC_DON_VI: "Xem hồ sơ cán bộ",
      MENU: "Phân Quyền menu cán bộ"
    },
    DON_VI: {
      NAME: "Quản lý đơn vị",
      DANH_SACH: "Đơn vị",
      TAO: "Chi tiết đơn vị",
      SUA: "Sửa đơn vị",
      TAO_MOI: "Thêm mới đơn vị",
      XEM: "Xem đơn vị"
    },
    THONG_BAO_TUY_CHINH: {
      NAME: "Thông báo tùy chỉnh",
      DANH_SACH: "Thông báo tùy chỉnh",
      XEM: "Xem thông báo tùy chỉnh"
    },
    TINH_THANH: {
      XEM: "Quản lý tỉnh thành phố"
    }
  },
  QUAN_TRI_HE_THONG: {
    NAME: "Quản trị hệ thống",
    VAI_TRO: "Quản lý vai trò",
    XEM_VAI_TRO: "Xem thông tin vai trò",
    CAP_NHAT_VAI_TRO: "Thao tác vai trò",
    NGUOI_DUNG: "Quản lý người dùng",
    XEM_NGUOI_DUNG: "Xem thông tin người dùng",
    CAP_NHAT_NGUOI_DUNG: "Quản lý người dùng",
    QUAN_LY_THONG_TIN_NGUOI_DUNG: "QTHT sửa thông tin cá nhân",
    APP: {
      NAME: "Quản lý ứng dụng",
      TAO: "Thêm mới ứng dụng",
      SUA: "Sửa thông tin ứng dụng",
      XEM: "Xem thông tin ứng dụng"
    },
    PERMISSION: {
      NAME: "Quản lý quyền"
    },
    GROUP: {
      NAME: "Quản lý nhóm người dùng",
      TAO: "Thêm nhóm người dùng",
      SUA: "Sửa nhóm người dùng",
      XEM: "Xem thông tin nhóm người dùng"
    },
    CHUC_VU: {
      NAME: "Quản lý chức vụ",
      TAO: "Thêm mới chức vụ",
      SUA: "Sửa chức vụ",
      XEM: "Xem chức vụ"
    },
    NHOM_CHUC_VU: {
      NAME: "Quản lý nhóm chức vụ",
      TAO: "Thêm mới nhóm chức vụ",
      SUA: "Sửa nhóm chức vụ",
      XEM: "Xem nhóm chức vụ"
    },
    CAP_DON_VI: {
      NAME: "Quản lý cấp đơn vị",
      TAO: "Thêm mới cấp đơn vị",
      SUA: "Sửa cấp đơn vị",
      XEM: "Xem cấp đơn vị"
    },
    DM_HE_THONG: {
      NAME: "Danh mục hệ thống",
      TAO: "Thêm mới danh mục hệ thống",
      SUA: "Sửa danh mục hệ thống",
      XEM: "Xem danh mục hệ thống"
    },
    IMPORT: {
      NAME: "Import dữ liệu"
    },
    DM_MENU_HE_THONG: {
      NAME: "Danh mục menu hệ thống",
      TAO: "Thêm mới danh mục menu hệ thống",
      SUA: "Sửa danh mục menu hệ thống",
      XEM: "Xem danh mục menu hệ thống"
    },
    DM_NHOM_MENU: {
      NAME: "Danh mục vai trò",
      TAO: "Thêm mới danh mục vai trò",
      SUA: "Sửa danh mục vai trò",
      XEM: "Xem danh mục vai trò"
    },
    THONG_BAO: {
      NAME: "Quản trị thông báo",
      QUAN_LY_NGUON_NHAN_THONG_BAO: "quản lý danh mục nhận thông báo",
      QUAN_LY_LOAI_THONG_BAO: "quản lý danh mục loại thông báo"
    },
    LOG: {
      NAME: "Trình nhật ký hệ thống"
    }
  },
  THONG_BAO: {
    NAME: "Thông báo",
    DANH_SACH_THONG_BAO_THEO_DANH_MUC: "Danh sách thông báo theo danh mục",
    XEM_THONG_BAO: "Xem thông báo",
    FORM_THONG_BAO: "Thêm, sửa thông báo"
  },
  LICH_LAM_VIEC: {
    NAME: "Lịch làm việc",
    FORM_LICH_LAM_VIEC: "Tạo, sửa lịch làm việc",
    TONG_HOP_LICH_LAM_VIEC: "Tổng hợp lịch làm việc",
    TRA_CUU_LICH_LAM_VIEC: "Tra cứu lịch làm việc",
    LICH_LAM_VIEC_CUA_LANH_DAO: "Lịch làm việc của lãnh đạo"
  }
};

export const PERMISSION_NAME = {
  QUAN_TRI_HE_THONG: "system_admin",
  NHOM_CHUC_VU: {
    QUAN_LY: "quan-ly-nhom-chuc-vu",
    THEM: "them-moi-nhom-chuc-vu",
    SUA: "sua-nhom-chuc-vu",
    XOA: "xoa-nhom-chuc-vu"
  },
  CHUC_VU: {
    QUAN_LY: "quan-ly-chuc-vu",
    THEM: "them-moi-chuc-vu",
    SUA: "sua-chuc-vu",
    XOA: "xoa-chuc-vu"
  },
  CAP_DON_VI: {
    QUAN_LY: "quan-ly-cap-don-vi",
    THEM: "them-moi-cap-don-vi",
    SUA: "sua-cap-don-vi",
    XOA: "xoa-cap-don-vi"
  },
  CAN_BO: {
    QUAN_LY: "quan-ly-ho-so-can-bo",
    XEM: "xem-chi-tiet-ho-so-can-bo",
    THEM: "them-moi-ho-so-can-bo",
    SUA: "sua-ho-so-can-bo",
    XOA: "xoa-ho-so-can-bo"
  },
  DON_VI: {
    QUAN_LY: "quan-ly-don-vi",
    XEM: "xem-chi-tiet-thong-tin-don-vi",
    THEM: "them-moi-thong-tin-don-vi",
    SUA: "sua-thong-tin-don-vi",
    XOA: "xoa-thong-tin-don-vi",
    THEM_CAN_BO_TRUC_THUOC: "them-can-bo-truc-thuoc-don-vi"
  },
  TINH_THANH: {
    QUAN_LY: "quan-ly-tinh-thanh-pho",
    XEM: "xem-chi-tiet-tinh-thanh-pho",
    THEM: "them-moi-tinh-thanh-pho",
    SUA: "sua-tinh-thanh-pho",
    XOA: "xoa-tinh-thanh-pho"
  },
  UNG_DUNG: {
    QUAN_LY: "quan-ly-ung-dung",
    THEM: "them-moi-ung-dung",
    SUA: "sua-ung-dung",
    XOA: "xoa-ung-dung",
    ADD_UNG_DUNG_VAO_NGUOI_DUNG: "chon-ung-dung-add-nguoi-dung",
    ADD_UNG_DUNG_VAO_VAI_TRO: "chon-ung-dung-phan-quyen-cho-vai-tro",
    ADD_UNG_DUNG_VAO_NHOM: "chon-ung-dung-phan-quyen-cho-nhom"
  },
  NHOM_NGUOI_DUNG: {
    QUAN_LY: "quan-ly-nhom-nguoi-dung",
    XEM: "xem-chi-tiet-thong-tin-nhom-nguoi-dung",
    THEM: "them-thong-tin-nhom-nguoi-dung",
    SUA: "sua-thong-tin-nhom-nguoi-dung",
    XOA: "xoa-nhom-nguoi-dung",
    PHAN_QUYEN: "phan-quyen-cho-nhom",
    THEM_NGUOI_DUNG: "them-nguoi-dung-vao-nhom",
    XOA_NGUOI_DUNG: "xoa-nguoi-dung-khoi-nhom"
  },
  QUYEN: {
    QUAN_LY: "quan-ly-quyen",
    PHAN_QUYEN_NGUOI_DUNG: "phan-quyen-nguoi-dung",
    PHAN_QUYEN_VAI_TRO: "phan-quyen-cho-vai-tro",
    PHAN_QUYEN_NHOM_NGUOI_DUNG: "phan-quyen-cho-nhom"
  },
  VAI_TRO: {
    QUAN_LY: "quan-ly-vai-tro",
    XEM: "xem-chi-tiet-thong-tin-nhom-nguoi-dung",
    THEM: "them-moi-vai-tro",
    SUA: "sua-thong-tin-vai-tro",
    XOA: "xoa-vai-tro",
    PHAN_QUYEN: "phan-quyen-cho-vai-tro",
    THEM_NGUOI_DUNG: "them-nguoi-dung-vao-vai-tro",
    XOA_NGUOI_DUNG: "xoa-nguoi-dung-khoi-vai-tro"
  },
  NGUOI_DUNG: {
    QUAN_LY: "quan-ly-nguoi-dung",
    XEM: "xem-chi-tiet-nguoi-dung",
    THEM: "them-nguoi-dung",
    SUA: "sua-thong-tin-nguoi-dung",
    XOA: "xoa-nguoi-dung",
    RESET_2FA: "reset-setting-2fa",
  },
  IMPORT: {
    IMPORT_DU_LIEU: "import-du-lieu",
    IMPORT_DON_VI: "import-don-vi",
    EXPORT_DON_VI: "export-don-vi",
    IMPORT_NHOM_CHUC_VU: "import-nhom-chuc-vu",
    EXPORT_NHOM_CHUC_VU: "import-nhom-chuc-vu",
    IMPORT_CHUC_VU: "import-chuc-vu",
    EXPORT_CHUC_VU: "export-chuc-vu",
    IMPORT_CAP_DON_VI: "import-cap-don-vi",
    EXPORT_CAP_DON_VI: "export-cap-don-vi",
    EXPORT_NGUOI_DUNG: "export-nguoi-dung",
    EXPORT_CAN_BO: "export-ho-so-can-bo",
    IMPORT_CAN_BO: "import-ho-so-can-bo"
  },
  LOG: {
    QUAN_LY: "quan-ly-log-he-thong"
  },
  THONG_BAO_TUY_CHINH: {
    XEM: "thongbao_xem"
  }
};

export const VAI_TRO_TAB = {
  THONG_TIN_VAI_TRO: "thong-tin-vai-tro",
  NGUOI_DUNG: "nguoi-dung",
  QUYEN: "quyen"
};

export const NGUOI_DUNG_TAB = {
  THONG_TIN_NGUOI_DUNG: "thong-tin-nguoi-dung",
  MAT_KHAU: "thiet-lap-mat-khau",
  VAI_TRO: "vai-tro",
  QUYEN: "quyen",
  CAN_BO: "can-bo"
};

export const GIA_TRI_NGUOI_DUNG_TAB = {
  THEM_MOI_NGUOI_DUNG: "Thêm người dùng",
  THONG_TIN_NGUOI_DUNG: "Thông tin người dùng",
  MAT_KHAU: "Thiết lập mật khẩu",
  VAI_TRO: "Quản lý vai trò",
  QUYEN: "Quản lý quyền",
  CAN_BO: "Quản lý cán bộ"
};

export const TINH_THANH_TAB = {
  VUNG : "vung",
  TINH_THANH: "tinh-thanh",
  QUAN_HUYEN: "quan-huyen",
  PHUONG_XA: "phuong-xa"
};

export const GIA_TRI_TINH_THANH_TAB = {
  VUNG: "Quản lý vùng",
  TINH_THANH: "Quản lý tỉnh thành phố",
  QUAN_HUYEN: "Quản lý quận huyện",
  PHUONG_XA: "Quản lý phường xã"
};

export const NO_RESULTS_TEXT = "Không tìm thấy kết quả";

export const TREE_SELECT_PLACEHOLDER = "Chọn đơn vị";

export const MA_TRA_LOI = {
  THANH_CONG: 1,
  THAT_BAI: 0
};

export const PERMISSION_ROLE = {
  XEM: "Xem",
  CAP_NHAT: "CapNhat"
};

export const BANG_DM_CHUC_VU = {
  stt: "STT",
  chucVu: "Tên chức vụ",
  nhomChucVu: "Nhóm chức vụ",
  thaoTac: "Thao tác"
};

export const BANG_DM_NHOM_CHUC_VU = {
  stt: "STT",
  nhomChucVu: "Tên nhóm chức vụ",
  thaoTac: "Thao tác"
};

export const BANG_DM_APP = {
  stt: "STT",
  name: "Tên ứng dụng",
  code: "Mã ứng dụng",
  description: "Mô tả",
  url: "URL",
  isActive: "Trạng thái",
  thaoTac: "Thao tác"
};

export const BANG_DM_DON_VI = {
  stt: "STT",
  tenDonVi: "Tên đơn vị",
  maDonVi: "Mã đơn vị",
  capDonVi: "Cấp đơn vị",
  soDonViTrucThuoc: "Số đơn vị trực thuộc",
  soDienThoai: "Số điện thoại",
  email: "Email",
  fax: "Fax",
  tacVu: "Tác vụ"
};

export const THONG_BAO_TUY_CHINH = {
  stt: "STT",
  tieuDe: "Tiêu đề",
  moTa: "Mô tả",
  ngayGui: "Ngày gửi",
  trangThai: "Trạng thái",
  thaoTac: "Thao tác"
};

export const BANG_NGUOI_DUNG = {
  checkbox: "",
  stt: "STT",
  name: "Họ và tên",
  userName: "Tên đăng nhập",
  donVi: "Đơn vị",
  vaiTro: "vai trò",
  trangThai: "Trạng thái",
  thaoTac: "Thao tác"
};

export const BANG_VAI_TRO = {
  checkbox: "",
  stt: "STT",
  name: "Tên vai trò",
  description: "Mô tả vai trò",
  displayName: "Tên hiển thị vai trò",
  appName: "Tên ứng dụng",
  thaoTac: "Thao tác"
};

export const BANG_DANH_SACH_QUYEN = {
  stt: "STT",
  name: "Mã quyền",
  displayName: "Tên quyền",
  appName: "Tên ứng dụng",
  thaoTac: "Thao tác"
};

export const BANG_DANH_SACH_LOG = {
  username: "Tên cán bộ",
  requestPath: "Action",
  createdDate: "Ngày tạo",
  requestBody: "Request Body"
};

export const BANG_THEM_CAN_BO_VAO_NGUOI_DUNG = {
  checkbox: "",
  stt: "STT",
  hoTen: "Họ và tên",
  userName: "Tên đăng nhập",
  thaoTac: "Thao tác"
};

export const THONG_TIN_TAI_KHOAN = {
  userName: "Tên đăng nhập",
  chucVu: "Chức vụ",
  donVi: "Đơn vị"
};

export const BANG_PHAM_VI_GROUP = {
  checkbox: "",
  name: "Tên phạm vi"
};

export const BO_QUA_BUTTON_LABEL = "Bỏ qua";
export const QUAY_LAI_BUTTON_LABEL = "Quay lại";
export const HUY_BO_BUTTON_LABEL = "Hủy bỏ";
export const DONG_Y_BUTTON_LABEL = "Đồng ý";

export const LICH_LAM_VIEC_CUA_LANH_DAO = "lich-lam-viec-cua-lanh-dao";
export const LICH_LAM_VIEC_CUA_DON_VI = "lich-lam-viec-cua-don-vi";
export const LICH_LAM_VIEC_CUA_CA_NHAN = "lich-lam-viec-cua-ca-nhan";
export const TRANG_THAI_THONG_BAO = {
  TAT_CA: 0,
  NHAP: 1,
  CHO_DUYET: 2,
  TU_CHOI_DUYET: 3,
  DA_DUYET: 4,
  DA_DANG: 5
};
export const QUAN_LY_DANH_MUC_TAB = {
  QUAN_LY_THONG_TIN_BO_TRO: "quan-ly-thong-tin-bo-tro",
  QUAN_LY_CHI_TIEU: "quan-ly-chi-tieu",
  QUAN_LY_THUOC_TINH: "quan-ly-thuoc-tinh"
};

export const QUAN_TRI_THONG_BA0_TAB = {
  QUAN_LY_NGUON_NHAN_THONG_BAO: "quan-ly-nguon-nhan-thong-bao",
  QUAN_LY_LOAI_THONG_BAO: "quan-ly-loai-thong-bao"
};

export const BANG_GROUP = {
  checkbox: "",
  stt: "STT",
  code: "Mã nhóm người dùng",
  name: "Tên nhóm người dùng",
  donVi: "Đơn vị",
  description: "Mô tả",
  appName: "Tên ứng dụng",
  thaoTac: "Thao tác"
};

export const GROUP_TAB = {
  THONG_TIN_GROUP: "thong-tin-nhom",
  NGUOI_DUNG: "nguoi-dung",
  QUYEN: "quyen",
  VAI_TRO: "vai-tro"
};

export const NAME_GROUP_TAB = {
  THONG_TIN_GROUP: "Thông tin nhóm",
  NGUOI_DUNG: "Quản lý người dùng",
  QUYEN: "Quản lý quyền",
  VAI_TRO: "Quản lý vai trò"
};

export const COMMON_TEXT = {
  APP_TITLE: "Quản trị Hệ thống - Cục CNTT và CDS",
  COPY_RIGHT: `© `+ new Date().getFullYear(),
  FORM_LOGIN: {
    TEN_DANG_NHAP: "Tên đăng nhập",
    MAT_KHAU: "Mật khẩu",
    BTN_DANGNHAP: "Đăng nhập"
  }
};
export const DANH_SACH_CAN_BO = [
  {
    key: "checkBox",
    label: ""
  },
  {
    key: "hoTen",
    label: "Họ tên"
  },
  {
    key: "phone_DiDong",
    label: "SĐT"
  },
  {
    key: "ngaySinh",
    label: "Ngày sinh"
  },
  {
    key: "email",
    label: "Email"
  },
  {
    key: "thoiGian_CapNhat",
    label: "Thời gian cập nhật"
  },
  {
    key: "anhDaiDien_FilePath",
    label: "Ảnh đại diện"
  },
  {
    key: "diaChi",
    label: "Địa chỉ"
  }
];
export const DANH_SACH_KEY_CAN_BO_TRUC_THUOC = [
  "Họ tên",
  "Chức vụ",
  "SĐT",
  "Ngày sinh",
  "Email",
  "Thời gian cập nhật",
  "Ảnh đại diện",
  "Địa chỉ",
  "Thao tác"
];
export const DANH_SACH_CAN_BO_TRUC_THUOC = [
  {
    key: "hoTen",
    label: "Họ tên"
  },
  {
    key: "chucVu",
    label: "Chức vụ"
  },
  {
    key: "phone_DiDong",
    label: "SĐT"
  },
  {
    key: "ngaySinh",
    label: "Ngày sinh"
  },
  {
    key: "email",
    label: "Email"
  },
  {
    key: "thoiGian_CapNhat",
    label: "Thời gian cập nhật"
  },
  {
    key: "anhDaiDien_FilePath",
    label: "Ảnh đại diện"
  },
  {
    key: "diaChi",
    label: "Địa chỉ"
  },
  {
    key: "thaoTac",
    label: "Thao tác"
  }
];

export const ENUM_TRANG_THAI_HOAT_DONG = {
  HOAT_DONG: 1,
  KHONG_HOAT_DONG: 2
};

export const MANG_TRANG_THAI_HOAT_DONG = [
  {
    key: ENUM_TRANG_THAI_HOAT_DONG.HOAT_DONG,
    label: "Hoạt động"
  },
  {
    key: ENUM_TRANG_THAI_HOAT_DONG.KHONG_HOAT_DONG,
    label: "Không hoạt động"
  }
];

export const ACTOR_TYPE_DATA = {
  USER_CANBO_DEPARTMENT: "USER_CANBO_DEPARTMENT",
  VAI_TRO: "VAI_TRO",
  GROUP: "GROUP"
};

export const IMPORT_TYPE = {
  ChucVu: "ChucVu",
  NhomChucVu: "NhomChucVu",
  DonVi: "DonVi",
  CapDonVi: "CapDonVi",
  CanBo: "CanBo",
  Multi: "Multi"
};

const CAP_DON_VI_FIELD_IMPORT = {
  TenCapDonVi: "TenCapDonVi",
  MaCapDonVi: "MaCapDonVi",
  MaCapDonViCha: "MaCapDonViCha",
  ThuTu: "ThuTu"
};

const NHOM_CHUC_VU_FIELD_IMPORT = {
  MaNhomChucVu: "MaNhomChucVu",
  TenNhomChucVu: "TenNhomChucVu",
  ThuTu: "ThuTu"
};

const CHUC_VU_FIELD_IMPORT = {
  TenChucVu: "TenChucVu",
  MaChucVu: "MaChucVu",
  MaNhomChucVu: "MaNhomChucVu",
  ThuTu: "ThuTu"
};

export const DON_VI_FIELD_IMPORT = {
  TenDonVi: "TenDonVi",
  MaDonVi: "MaDonVi",
  MaDonViCha: "MaDonViCha",
  MaLienThong: "MaLienThong",
  ThuTu: "ThuTu",
  Email: "Email",
  SoDienThoai: "SoDienThoai",
  Fax: "Fax",
  LoaiDonVi: "LoaiDonVi",
  DiaChiTheoDonViCha: "DiaChiTheoDonViCha",
  LaDonViAo: "LaDonViAo",
  LaDonViNgoai: "LaDonViNgoai",
  MaCapDonVi: "MaCapDonVi",
  DiaChi: "DiaChi"
};

export const CAN_BO_FIELD_IMPORT = {
  HoVaTen: "HoVaTen",
  MaCanBo: "MaCanBo",
  ThuTu: "ThuTu",
  GioiTinh: "GioiTinh",
  NgaySinh: "NgaySinh",
  Email: "Email",
  SoCMND: "SoCMND",
  SoDienThoaiCoQuan: "SoDienThoaiCoQuan",
  SoDienThoaiCaNhan: "SoDienThoaiCaNhan",
  DiaChiLienHe: "DiaChiLienHe",
  HinhThucNhanTin: "HinhThucNhanTin",
  LanhDaoDonVi: "LanhDaoDonVi",
  DonVi: "DonVi",
  ChucVu: "ChucVu",
  TenDangNhap: "TenDangNhap"
};

export const FIELD_IMPORT = {
  CAP_DON_VI: [
    {
      key: CAP_DON_VI_FIELD_IMPORT.TenCapDonVi,
      keySearch: CAP_DON_VI_FIELD_IMPORT.TenCapDonVi,
      value: "Tên cấp đơn vị *"
    },
    {
      key: CAP_DON_VI_FIELD_IMPORT.MaCapDonVi,
      keySearch: CAP_DON_VI_FIELD_IMPORT.MaCapDonVi,
      value: "Mã cấp đơn vị *"
    },
    {
      key: CAP_DON_VI_FIELD_IMPORT.MaCapDonViCha,
      keySearch: CAP_DON_VI_FIELD_IMPORT.MaCapDonViCha,
      value: "Mã cấp đơn vị cha"
    },
    {
      key: CAP_DON_VI_FIELD_IMPORT.ThuTu,
      keySearch: CAP_DON_VI_FIELD_IMPORT.ThuTu,
      value: "Thứ tự"
    }
  ],
  NHOM_CHUC_VU: [
    {
      key: NHOM_CHUC_VU_FIELD_IMPORT.MaNhomChucVu,
      keySearch: NHOM_CHUC_VU_FIELD_IMPORT.MaNhomChucVu,
      value: "Mã nhóm chức vụ *"
    },
    {
      key: NHOM_CHUC_VU_FIELD_IMPORT.TenNhomChucVu,
      keySearch: NHOM_CHUC_VU_FIELD_IMPORT.TenNhomChucVu,
      value: "Tên nhóm chức vụ *"
    },
    {
      key: NHOM_CHUC_VU_FIELD_IMPORT.ThuTu,
      keySearch: NHOM_CHUC_VU_FIELD_IMPORT.ThuTu,
      value: "Thứ tự"
    }
  ],
  CHUC_VU: [
    {
      key: CHUC_VU_FIELD_IMPORT.TenChucVu,
      keySearch: CHUC_VU_FIELD_IMPORT.TenChucVu,
      value: "Tên chức vụ *"
    },
    {
      key: CHUC_VU_FIELD_IMPORT.MaChucVu,
      keySearch: CHUC_VU_FIELD_IMPORT.MaChucVu,
      value: "Mã chức vụ *"
    },
    {
      key: CHUC_VU_FIELD_IMPORT.MaNhomChucVu,
      keySearch: CHUC_VU_FIELD_IMPORT.MaNhomChucVu,
      value: "Mã nhóm chức vụ"
    },
    {
      key: CHUC_VU_FIELD_IMPORT.ThuTu,
      keySearch: CHUC_VU_FIELD_IMPORT.ThuTu,
      value: "Thứ tự"
    }
  ],
  DON_VI: [
    {
      key: DON_VI_FIELD_IMPORT.TenDonVi,
      keySearch: DON_VI_FIELD_IMPORT.TenDonVi,
      value: "Tên đơn vị *"
    },
    {
      key: DON_VI_FIELD_IMPORT.MaDonVi,
      keySearch: DON_VI_FIELD_IMPORT.MaDonVi,
      value: "Mã đơn vị *"
    },
    {
      key: DON_VI_FIELD_IMPORT.MaDonViCha,
      keySearch: DON_VI_FIELD_IMPORT.MaDonViCha,
      value: "Mã đơn vị cha"
    },
    {
      key: DON_VI_FIELD_IMPORT.MaLienThong,
      keySearch: DON_VI_FIELD_IMPORT.MaLienThong,
      value: "Mã liên thông"
    },
    {
      key: DON_VI_FIELD_IMPORT.ThuTu,
      keySearch: DON_VI_FIELD_IMPORT.ThuTu,
      value: "Thứ tự"
    },
    {
      key: DON_VI_FIELD_IMPORT.Email,
      keySearch: DON_VI_FIELD_IMPORT.Email,
      value: "Email"
    },
    {
      key: DON_VI_FIELD_IMPORT.SoDienThoai,
      keySearch: DON_VI_FIELD_IMPORT.SoDienThoai,
      value: "Số điện thoại"
    },
    {
      key: DON_VI_FIELD_IMPORT.Fax,
      keySearch: DON_VI_FIELD_IMPORT.Fax,
      value: "Fax"
    },
    {
      key: DON_VI_FIELD_IMPORT.LoaiDonVi,
      keySearch: DON_VI_FIELD_IMPORT.LoaiDonVi,
      value: "Loại đơn vị"
    },
    {
      key: DON_VI_FIELD_IMPORT.DiaChiTheoDonViCha,
      keySearch: DON_VI_FIELD_IMPORT.DiaChiTheoDonViCha,
      value: "Địa chỉ theo đơn vị cha"
    },
    {
      key: DON_VI_FIELD_IMPORT.LaDonViAo,
      keySearch: DON_VI_FIELD_IMPORT.LaDonViAo,
      value: "Là đơn vị ảo"
    },
    {
      key: DON_VI_FIELD_IMPORT.LaDonViNgoai,
      keySearch: DON_VI_FIELD_IMPORT.LaDonViNgoai,
      value: "Là đơn vị ngoài"
    },
    {
      key: DON_VI_FIELD_IMPORT.MaCapDonVi,
      keySearch: DON_VI_FIELD_IMPORT.MaCapDonVi,
      value: "Mã cấp đơn vị"
    },
    {
      key: DON_VI_FIELD_IMPORT.DiaChi,
      keySearch: DON_VI_FIELD_IMPORT.DiaChi,
      value: "Địa chỉ"
    }
  ],
  CAN_BO: [
    {
      key: CAN_BO_FIELD_IMPORT.HoVaTen,
      keySearch: CAN_BO_FIELD_IMPORT.HoVaTen,
      value: "Họ và tên *"
    },
    {
      key: CAN_BO_FIELD_IMPORT.MaCanBo,
      keySearch: CAN_BO_FIELD_IMPORT.MaCanBo,
      value: "Mã cán bộ *"
    },
    {
      key: CAN_BO_FIELD_IMPORT.ThuTu,
      keySearch: CAN_BO_FIELD_IMPORT.ThuTu,
      value: "Thứ tự"
    },
    {
      key: CAN_BO_FIELD_IMPORT.GioiTinh,
      keySearch: CAN_BO_FIELD_IMPORT.GioiTinh,
      value: "Giới tính"
    },
    {
      key: CAN_BO_FIELD_IMPORT.NgaySinh,
      keySearch: CAN_BO_FIELD_IMPORT.NgaySinh,
      value: "Ngày sinh"
    },
    {
      key: CAN_BO_FIELD_IMPORT.Email,
      keySearch: CAN_BO_FIELD_IMPORT.Email,
      value: "Email"
    },
    {
      key: CAN_BO_FIELD_IMPORT.SoCMND,
      keySearch: CAN_BO_FIELD_IMPORT.SoCMND,
      value: "Số CMND"
    },
    {
      key: CAN_BO_FIELD_IMPORT.SoDienThoaiCoQuan,
      keySearch: CAN_BO_FIELD_IMPORT.SoDienThoaiCoQuan,
      value: "Số điện thoại cơ quan"
    },
    {
      key: CAN_BO_FIELD_IMPORT.SoDienThoaiCaNhan,
      keySearch: CAN_BO_FIELD_IMPORT.SoDienThoaiCaNhan,
      value: "Số điện thoại cá nhân"
    },
    {
      key: CAN_BO_FIELD_IMPORT.DiaChiLienHe,
      keySearch: CAN_BO_FIELD_IMPORT.DiaChiLienHe,
      value: "Địa chỉ liên hệ"
    },
    {
      key: CAN_BO_FIELD_IMPORT.HinhThucNhanTin,
      keySearch: CAN_BO_FIELD_IMPORT.HinhThucNhanTin,
      value: "Hình thức nhận tin"
    },
    {
      key: CAN_BO_FIELD_IMPORT.LanhDaoDonVi,
      keySearch: CAN_BO_FIELD_IMPORT.LanhDaoDonVi,
      value: "Lãnh đạo đơn vị"
    },
    {
      key: CAN_BO_FIELD_IMPORT.DonVi,
      keySearch: CAN_BO_FIELD_IMPORT.DonVi,
      value: "Đơn vị"
    },
    {
      key: CAN_BO_FIELD_IMPORT.ChucVu,
      keySearch: CAN_BO_FIELD_IMPORT.ChucVu,
      value: "Chức vụ"
    },
    {
      key: CAN_BO_FIELD_IMPORT.TenDangNhap,
      keySearch: CAN_BO_FIELD_IMPORT.TenDangNhap,
      value: "Tên đăng nhập *"
    }
  ]
};

export const FILTER_TRUE_FALSE = [
  { key: null, label: "Tất cả" },
  { key: "Có", label: "Có" },
  { key: "Không", label: "Không" }
];
